(function () {
  function track(eventName, payload) {
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      window.Shopify.analytics.publish(eventName, payload || {});
    }

    if (window.gtag) {
      window.gtag('event', eventName, payload || {});
    }
  }

  document.addEventListener('nfd:find-my-size-open', function () {
    track('find_my_size_open');
  });

  document.addEventListener('nfd:find-my-size-submit', function () {
    track('find_my_size_submit');
  });

  document.addEventListener('nfd:size-profile-save', function (e) {
    track('find_my_size_saved_profile', {
      has_measurements: !!(e.detail && e.detail.jeans)
    });
  });
})();